<template><div><h1>VUX V2.1.1Rc.10 发布日志</h1>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 支持多个 less 变量. #896</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 支持 on-focus 事件</li>
</ul>
<h2><a href="/zh-CN/components/timeline.html">Timeline</a></h2>
<ul><li>[fix] 修复图标位置</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] 修复警告图标样式</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] 添加禁用背景颜色. #896</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 支持 reset 函数 #947 @erguotou520</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.10 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.10-205.vue?f709ec60